import React from "react";

const UserPopover = (props) => {
  const { children } = props;

  return <div className="user-popover">{children}</div>;
};

export default UserPopover;
